import * as React from 'react';

var _rect, _path, _g, _path2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgAutoTheme(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 110,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 139,
    height: 109,
    rx: 3.5,
    fill: "#1F2326",
    stroke: "#737577"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "auto-theme_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 4,
    width: 133,
    height: 106
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.81 55.893l.004-.004L133.872 5.32c2.303-1.762 5.628-.12 5.628 2.78V106a3.5 3.5 0 01-3.5 3.5H11.322c-3.301 0-4.767-4.15-2.2-6.223L67.81 55.893z",
    fill: "#24272B",
    stroke: "#737577"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#auto-theme_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 50,
    width: 116,
    height: 5,
    rx: 2.5,
    fill: "#737577"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 72,
    width: 116,
    height: 5,
    rx: 2.5,
    fill: "#737577"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 61,
    width: 116,
    height: 5,
    rx: 2.5,
    fill: "#737577"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 83,
    width: 116,
    height: 5,
    rx: 2.5,
    fill: "#737577"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 94,
    width: 17,
    height: 7,
    rx: 2,
    fill: "#0080E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 30.5C35 36.851 29.851 42 23.5 42S12 36.851 12 30.5 17.149 19 23.5 19 35 24.149 35 30.5zm-16.06 0a4.56 4.56 0 109.12 0 4.56 4.56 0 00-9.12 0z",
    fill: "#FDA332"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "auto-theme_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 140,
    height: 109
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 .5h134.572L80.193 47.105l-.005.004-78.881 61.244a.5.5 0 01-.807-.395V4A3.5 3.5 0 014 .5z",
    fill: "#1F2326",
    stroke: "#DFE5EB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#auto-theme_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 .5h133.145a.5.5 0 01.311.89L80.193 47.106l-.005.004L2.92 107.1c-.986.765-2.42.063-2.42-1.185V4A3.5 3.5 0 014 .5z",
    fill: "#fff",
    stroke: "#DFE5EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8,
    width: 83,
    height: 5,
    rx: 2.5,
    fill: "#DFE5EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 50,
    width: 116,
    height: 5,
    rx: 2.5,
    fill: "#DFE5EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 72,
    width: 116,
    height: 5,
    rx: 2.5,
    fill: "#DFE5EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 61,
    width: 116,
    height: 5,
    rx: 2.5,
    fill: "#DFE5EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 83,
    width: 116,
    height: 5,
    rx: 2.5,
    fill: "#DFE5EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 94,
    width: 17,
    height: 7,
    rx: 2,
    fill: "#0080E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 30.5C35 36.851 29.851 42 23.5 42S12 36.851 12 30.5 17.149 19 23.5 19 35 24.149 35 30.5zm-16.06 0a4.56 4.56 0 109.12 0 4.56 4.56 0 00-9.12 0z",
    fill: "#FDA332"
  }))));
}

export { SvgAutoTheme as ReactComponent };
